import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/site/Layout";
import HomePage from "@/pages/Home";

// Lazy-loaded routes — each page's JS (and heavy data like blog posts)
// only downloads when a visitor actually navigates there, instead of
// bloating the initial bundle every visitor pays for on first load.
const DestinationsHub = lazy(() => import("@/pages/Destinations"));
const DestinationDetail = lazy(() => import("@/pages/DestinationDetail"));
const BlogHub = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const FAQPage = lazy(() => import("@/pages/FAQ"));
const AboutPage = lazy(() => import("@/pages/About"));
const ContactPage = lazy(() => import("@/pages/Contact"));
const PrivacyPage = lazy(() => import("@/pages/Privacy"));
const TermsPage = lazy(() => import("@/pages/Terms"));
const SitemapPage = lazy(() => import("@/pages/Sitemap"));
const NotFoundPage = lazy(() => import("@/pages/NotFound"));

// Slug → destination route map (keeps SEO-friendly URLs from the brief)
const DEST_ROUTES = [
  { path: "/andaman-tour-packages", slug: "andaman" },
  { path: "/goa-tour-packages", slug: "goa" },
  { path: "/rajasthan-tour-packages", slug: "rajasthan" },
  { path: "/leh-ladakh-tour-packages", slug: "leh-ladakh" },
];

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="/destinations" element={<DestinationsHub />} />
            {/* SEO-friendly destination routes */}
            {DEST_ROUTES.map((r) => (
              <Route key={r.path} path={r.path} element={<DestinationDetail slugOverride={r.slug} />} />
            ))}
            {/* Also allow /destinations/:slug for internal linking */}
            <Route path="/destinations/:slug" element={<DestinationDetail />} />
            <Route path="/blog" element={<BlogHub />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
